import { ActivityComposer as Shared } from "@/components/activity/ActivityComposer"

export function ClipActivityComposer({ clipId }: { clipId: number }) {
  return <Shared eventsPath={`/clips/${clipId}/events`} />
}
